import React, { useState } from 'react';
import { Form, Button, Row, Col, Select, Input, message } from 'antd';
import { MinusCircleOutlined } from '@ant-design/icons';
import { BASE_URL } from '../Components/Constant';
import ApiService from '../Components/apiService';

const { Option } = Select;

const InitialSubmissionAction = ({ availableFields , selectedObject }) => {
  const [picklistValues, setPicklistValues] = useState({});
  const [lookupOptions, setLookupOptions] = useState([]); // For storing lookup options


   // Function to fetch lookup records
   const fetchLookupRecords = async (parentObjectName) => {
    try {
      const apiServiceForRecords = new ApiService(
        `${BASE_URL}/fetch_records/${parentObjectName}`,
        { "Content-Type": "application/json" },
        "GET"
      );
      const response = await apiServiceForRecords.makeCall();
      // Assuming response is an array of records with _id and Name fields
      const records = response?.records?.map((record) => ({
        value: record._id, // Set _id as value
        label: record.Name, // Set Name as label
      }));
      setLookupOptions(records); // Set options for the lookup field
    } catch (error) {
      const errorMessage =
        error && typeof error === "object"
          ? Object.entries(error)
              .map(
                ([key, value]) =>
                  `${key}: ${Array.isArray(value) ? value.join(", ") : value}`
              )
              .join(" | ")
          : "Failed to save field due to an unknown error";
      message.error(errorMessage);
    }
  };

  const handleFieldChange = (fieldName, fieldKey) => {
    // Find the selected field from availableFields
    const selectedField = availableFields.find((field) => field.name === fieldName);

    if (selectedField?.type === 'picklist') {
    }
  
    if (selectedField?.type === 'lookup' && selectedField.parent_object_name) {
      fetchLookupRecords(selectedField.parent_object_name);
    } else {
      setLookupOptions([]);
    }


    // Update picklistValues state with the picklist options if the field is a picklist type
    setPicklistValues((prev) => ({
      ...prev,
      [fieldKey]: selectedField?.type === 'picklist' ? selectedField.picklist_values : null,
    }));
  };

  return (
    <Form.List name="filterCriteria">
      {(fields, { add, remove }) => (
        <>
          <Row style={{ marginBottom: 20 }}>
            <Col>
              <Button type="primary" onClick={() => add()}>
                Add New
              </Button>
            </Col>
          </Row>
          {fields.map(({ key, name, fieldKey, ...restField }) => (
            <Row key={key} gutter={10} align="middle" style={{ marginBottom: '10px' }}>
              <Col span={7}>
                <Form.Item
                  {...restField}
                  name={[name, 'action']}
                  fieldKey={[fieldKey, 'action']}
                  rules={[{ required: true, message: 'Please input the action!' }]}
                >
                  <Select placeholder="Select Action">
                    <Option value="update_field">Update Field</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={7}>
                <Form.Item
                  {...restField}
                  name={[name, 'field']}
                  fieldKey={[fieldKey, 'field']}
                  rules={[{ required: true, message: 'Field is required!' }]}
                >
                  <Select
                    placeholder="Select Field"
                    onChange={(value) => handleFieldChange(value, fieldKey)}
                  >
                    {availableFields.map((field) => (
                      <Option key={field._id} value={field.name}>
                        {field.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={7}>
              <Form.Item
                  {...restField}
                  name={[name, 'value']}
                  fieldKey={[fieldKey, 'value']}
                  rules={[{ required: true, message: 'Value is required!' }]}
                >
                  {lookupOptions.length > 0 ? (
                    <Select placeholder="Select Lookup Value">
                      {lookupOptions.map((option) => (
                        <Option key={option.value} value={option.value}>
                          {option.label}
                        </Option>
                      ))}
                    </Select>
                  ) : picklistValues[fieldKey] ? (
                    <Select placeholder="Select Value">
                      {picklistValues[fieldKey].map((value) => (
                        <Option key={value} value={value}>
                          {value}
                        </Option>
                      ))}
                    </Select>
                  ) : (
                    <Input placeholder="Enter Value" />
                  )}
                </Form.Item>
              </Col>
              <Col span={1} style={{ textAlign: 'center', marginBottom: 20 }}>
                <MinusCircleOutlined onClick={() => remove(name)} />
              </Col>
            </Row>
          ))}
        </>
      )}
    </Form.List>
  );
};

export default InitialSubmissionAction;
